import React from "react";

import { i18n } from "../../translate/i18n";
import "./RecentTicketSearches.css";

function ClockIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden
		>
			<circle cx="12" cy="12" r="10" />
			<path d="M12 6v6l4 2" />
		</svg>
	);
}

function CloseIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden
		>
			<path d="M18 6 6 18M6 6l12 12" />
		</svg>
	);
}

function preventBlur(event) {
	event.preventDefault();
}

export default function RecentTicketSearches({
	open,
	items = [],
	dark = false,
	onSelect,
	onRemove,
	onClear,
}) {
	if (!open || !items.length) return null;

	return (
		<div
			className={`recent-ticket-searches${dark ? " recent-ticket-searches--dark" : ""}`}
			role="listbox"
			aria-label={i18n.t("tickets.search.recentTitle")}
		>
			<div className="recent-ticket-searches__header">
				<span className="recent-ticket-searches__title">
					{i18n.t("tickets.search.recentTitle")}
				</span>
				<button
					type="button"
					className="recent-ticket-searches__clear"
					onMouseDown={preventBlur}
					onClick={onClear}
				>
					{i18n.t("tickets.search.recentClear")}
				</button>
			</div>
			<ul className="recent-ticket-searches__list">
				{items.map((term) => (
					<li key={term} className="recent-ticket-searches__item">
						<button
							type="button"
							className="recent-ticket-searches__select"
							role="option"
							onMouseDown={preventBlur}
							onClick={() => onSelect(term)}
						>
							<span className="recent-ticket-searches__icon">
								<ClockIcon />
							</span>
							<span className="recent-ticket-searches__term">{term}</span>
						</button>
						<button
							type="button"
							className="recent-ticket-searches__remove"
							aria-label={i18n.t("tickets.search.recentRemove")}
							onMouseDown={preventBlur}
							onClick={() => onRemove(term)}
						>
							<CloseIcon />
						</button>
					</li>
				))}
			</ul>
		</div>
	);
}
